import { RecognisedHeaderLabels } from 'common/enums/known-data-enums.js';
import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

const fracturePressureMap = new Map();

fracturePressureMap.set(KnowEdmTableData.Tvd, {
  key: KnowEdmTableData.Tvd,
  label: RecognisedHeaderLabels.DepthTVD,
  unit: defaultUnits.get(QuantitiesTypes.Length),
  quantity: QuantitiesTypes.Length,
});

fracturePressureMap.set(KnowEdmTableData.FracturePressureGradient, {
  key: KnowEdmTableData.FracturePressureGradient,
  label: RecognisedHeaderLabels.FracturePressureGradient,
  unit: defaultUnits.get(QuantitiesTypes.Density),
  quantity: QuantitiesTypes.Density,
});

fracturePressureMap.set(KnowEdmTableData.FracturePressure, {
  key: KnowEdmTableData.FracturePressure,
  label: RecognisedHeaderLabels.FracturePressure,
  unit: defaultUnits.get(QuantitiesTypes.PressureСhange),
  quantity: QuantitiesTypes.PressureСhange,
});

export {
  fracturePressureMap,
};